import React from 'react';
import { GridWrapper } from '@yme/atoms/grid';
import { Skeleton } from '@yme/common/components/skeletons';
import { AspectRatio } from '@yme/utils/constants';
export function ProductVideoSkeleton() {
    return (React.createElement(GridWrapper, null,
        React.createElement(Skeleton, { skeletonProps: {
                style: {
                    aspectRatio: AspectRatio.RectangleLevel4,
                },
            } })));
}
